/* eslint-disable no-debugger */
import { map, filter } from 'lodash';
import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from 'axios';

const initialState = {
  isLoading: false,
  error: '',
  scoringMsg: '',
  status: true,
  createScoringStatus: false,
  externalModelApi: [],
  scoringList: [],
  disableScoringList: []
};

const slice = createSlice({
  name: 'scoring',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    // RESET ERROR
    resetScoringError(state) {
      state.error = '';
    },
    // RESET MSG
    resetScoringMsg(state) {
      state.scoringMsg = '';
    },
    // RESET CREATE STATUS
    resetCreateScoringStatus(state) {
      state.createScoringStatus = false;
    },
    // HAS ERROR
    hasError(state, action) {
      const { message } = action.payload?.data;
      state.createScoringStatus = false;
      state.isLoading = false;
      state.error = message;
    },
    // STATUS
    scoringStatus(state, action) {
      state.isLoading = false;
      state.status = action.payload;
    },
    // GET EXTERNAL MODEL LIST
    getExternalModelApiSuccess(state, action) {
      state.externalModelApi = action.payload;
      state.isLoading = false;
    },
    // GET SCORING LIST
    getScoringListSuccess(state, action) {
      state.scoringList = action.payload;
      state.isLoading = false;
    },
    // GET DISABLE SCORING LIST
    getDisableScoringListSuccess(state, action) {
      state.disableScoringList = action.payload;
      state.isLoading = false;
    },
    // CREATE SCORING
    createScoringSuccess(state, action) {
      const newScoring = action.payload;
      state.createScoringStatus = true;
      state.isLoading = false;
      state.scoringList = [...state.scoringList, newScoring];
    },
    // UPDATE SCORING
    updateScoringSuccess(state, action) {
      const scoring = action.payload;
      state.createScoringStatus = true;
      const updateScoring = map(state.scoringList, (_scoring) => {
        if (_scoring.id === scoring.id) {
          return scoring;
        }
        return _scoring;
      });
      state.isLoading = false;
      state.scoringList = updateScoring;
    },
    // FILTER SCORING
    filterScoringSuccess(state, action) {
      const scoring = action.payload;
      state.isLoading = false;
      if (state.status) {
        state.scoringList = scoring;
      } else {
        state.disableScoringList = scoring;
      }
    },
    // DISABLE OR RESTORE SCORING
    statusChangeSuccess(state, action) {
      if (action.payload.message) {
        state.scoringMsg = action.payload.message;
      } else {
        const { id } = action.payload;
        const scoringStatus = filter(
          state.status ? state.disableScoringList : state.scoringList,
          (scoring) => scoring.id !== id
        );
        state.isLoading = false;
        if (state.status) {
          state.createScoringStatus = false;
          state.scoringMsg = '';
          state.disableScoringList = scoringStatus;
        } else {
          state.createScoringStatus = true;
          state.scoringList = scoringStatus;
        }
      }
    },
    // DELETE SCORING
    deleteScoringSuccess(state, action) {
      const { id } = action.payload;
      const deleteEvent = filter(state.disableScoringList, (scoring) => scoring.id !== id);
      state.isLoading = false;
      state.disableScoringList = deleteEvent;
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const { resetCreateScoringStatus, resetScoringError, resetScoringMsg } = slice.actions;

// ----------------------------------------------------------------------

// GET SCORING LIST GET
export function getScoringList(status) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'get',
        url: `http://smartcollect-api.cp360apps.com/collection-data/scoring-model/filter/item/?status=${status}`
      });
      if (status) {
        dispatch(slice.actions.getScoringListSuccess(response.data));
      } else {
        dispatch(slice.actions.getDisableScoringListSuccess(response.data));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// GET EXTERNAL MODEL LIST GET
export function getExternalModelApi() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'get',
        url: `http://smartcollect-api.cp360apps.com/collection-data/scoring-model/external-model/`
      });
      dispatch(slice.actions.getExternalModelApiSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// CREATE SCORING POST
export function createScoringModel(scoringData) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'post',
        url: 'http://smartcollect-api.cp360apps.com/collection-data/scoring-model-create/',
        data: scoringData
      });
      dispatch(slice.actions.createScoringSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// EDIT OR UPDATE SCORING PUT
export function updateScoringModel(scoringData, id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'put',
        url: `http://smartcollect-api.cp360apps.com/collection-data/scoring-model-edit/${id}/`,
        data: scoringData
      });
      dispatch(slice.actions.updateScoringSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// SEARCH AND FILTER SCORING GET
export function filterScoring(pageStatus, name) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.scoringStatus(pageStatus));
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'get',
        url: `http://smartcollect-api.cp360apps.com/collection-data/scoring-model/filter/item/?status=${pageStatus}&scoring_model_name=${name}`
      });
      dispatch(slice.actions.filterScoringSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// DISABLING OR RESTORING OF PARTICULAR SCORING PUT
export function statusChange(id, status) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.scoringStatus(status));
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'put',
        url: `http://smartcollect-api.cp360apps.com/collection-data/scoring-model/update-status-${status}/${id}/`
      });
      dispatch(slice.actions.statusChangeSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// DELETE SCORING DELETE
export function deleteScoring(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'delete',
        url: `http://smartcollect-api.cp360apps.com/collection-data/scoring-model/delete/${id}/`
      });
      dispatch(slice.actions.deleteScoringSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------
